/**
 * Search configuration constants
 */
export const SEARCH_CONFIG = {
  /** Debounce delay for filter count updates while typing (ms) */
  FILTER_COUNTS_DEBOUNCE_MS: 1000, // Reduced from 2000ms for better responsiveness
  /** Minimum FTS results before triggering fuzzy fallback */
  FTS_FUZZY_THRESHOLD: 5,
} as const;
